interface ReferralResponse {
  data?: {
    name: string;
    code: string;
    phone: string;
  };
  ok: boolean;
  error?: {
    code: string;
    message: string;
    ref: string;
  };
}

export const validateReferralCode = async (refCode: string): Promise<{ referralCode: string; referralName: string; phoneNumber: string }> => {
  try {
    const response = await fetch(`https://marketing.app.aqiqahpedia.id/api/agents/resolve?ref=${refCode}`);
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data: ReferralResponse = await response.json();
    
    if (data.ok && data.data) {
      return {
        referralCode: data.data.code,
        referralName: data.data.name || 'Call Center',
        phoneNumber: (data.data.phone && String(data.data.phone).trim() !== '' ? data.data.phone : '6285700141117')
      };
    } else {
      // If referral not found, return default values
      return {
        referralCode: 'call-center',
        referralName: 'Call Center',
        phoneNumber: '6285700141117'
      };
    }
  } catch (error) {
    console.error('Error validating referral code:', error);
    // Return default values on error
    return {
      referralCode: 'call-center',
      referralName: 'Call Center',
      phoneNumber: '6285700141117'
    };
  }
};


